export enum PurchaseType {
  RFQ = 'Request for Quotation',
  TENDER = 'Tender',
  DC = 'WOC-DOTP',
  ONLINE = 'Online Purchases',
  SMALL = 'Small Value Purchase',
  PM = 'Other Permissible Reasons',
  CORPORATE_CARD = 'Corporate Credit Card Purchase',
  OPTION_TO_PURCHASE = 'Exercise Option-to-Purchase',
  PERMISSIBLE_COVERING = 'Permissible Covering PO',
  STAFF_REIMBURSEMENT = 'Staff reimbursement',
  BLANKET = 'Blanket Purchase Request',
  EXCEPTIONAL_PO = "Exceptional purchase order",
  PCPO = 'Permissible Covering PO'
}

export const PurchaseTypeMap: Record<number, string> = {
  1: PurchaseType.RFQ,
  2: PurchaseType.SMALL,
  3: PurchaseType.CORPORATE_CARD,
  4: PurchaseType.OPTION_TO_PURCHASE,
  5: PurchaseType.DC,
  6: PurchaseType.TENDER,
  9: PurchaseType.PERMISSIBLE_COVERING,
  10: PurchaseType.ONLINE,
  11: PurchaseType.STAFF_REIMBURSEMENT,
  12: PurchaseType.BLANKET,
  13: PurchaseType.EXCEPTIONAL_PO
};

export enum WorflowHistory {
  OPSApproval = 'OPSApproval',
  CARApproval = 'CARApproval',
  CAPAUCApproval = 'CAPAUCApproval',
  RESApproval = 'RESApproval',
  WOCApproval = 'WOCApproval',
  VendorDocumentApproval = 'VendorDocumentApproval',
  SOWApproval = 'SOWApproval',
  TenderApproval = 'TenderApproval',
  DOTPApproval = 'DOTPApproval',
}

export enum ActionEnum {
  PENDING_RECOMMENDATION = 'Pending Recommendation', // use for alert message
  APPROVED = 'Approved', // use for alert message
  REJECTED = 'Rejected', // use for alert message
  RECOMMENDED = 'Recommended', // use for alert message
  NOT_RECOMMENDED = 'Not Recommended', // use for alert message
  CANCELLED = 'Cancelled',
  PENDING_APPROVAL = 'Pending Approval', // use for alert message
  PENDING_ENDORSEMENT = 'Pending Endorsement', // use for alert message
  SKIPPED_RECOMMENDATION = 'Skipped Recommendation (1-step Approval)',
  APPROVAL_NOT_REQUIRED = 'Approval not required',
  RECALLED = 'Recalled',
  WORKFLOW_STARTED = 'Workflow Started',
  FORWARDED = 'Forwarded',
  ENDORSED = 'Endorsed', // use for alert message
  NOT_ENDORSED = 'Not Endorsed', // use for alert message
  PENDING_RELEASE = 'Pending Release', // use for alert message
  RELEASED = 'Released', // use for alert message
  NOT_RELEASED = 'Not Released', // use for alert message
  PENDING_ASSIGNMENT = 'Pending Assignment',
  ASSIGNED = 'Assigned',
  PENDING_SUBMISSION = 'Pending Submission',
  SUBMITTED = 'Submitted',
  TERMINATED = 'Terminated',
  PENDING_PRIOR_APPROVAL = 'Pending Prior Approval',
}

// Pending Recommendation
// Approved
// Rejected
// Recommended
// Not Recommended
// Cancelled
// Pending Approval
// Pending Endorsement
// Skipped Recommendation (1-step Approval)
// Approval not required
// Recalled
// Workflow Started
// Forwarded
// Endorsed
// Not Endorsed
// Pending Release
// Released
// Not Released
// Pending Assignment
// Assigned
// Pending Submission
// Submitted
// Terminated
// Pending Prior Approval

// OPSApproval, CARApproval, CAPAUCApproval, RESApproval, WOCApproval, VendorDocumentApproval, SOWApproval, TenderApproval
